import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from '../../services/user.service';
import {MessageComponent} from '../../components/messages/message.component';
import {ViewChild} from '@angular/core';


@Component({templateUrl: './apps.html', styleUrls: ['./apps.scss']})
export class AppsComponent implements OnInit {
  public applications;

  @ViewChild(MessageComponent) public messageComponent: MessageComponent;

  public constructor(private users: UserService) {}

  ngOnInit() { this.loadApps(); }

  loadApps() {
    this.users.getUserApps().subscribe(
        res => {
          this.applications = new Array();
          this.applications = res;

          this.applications.map(app => {
            if (!app.platform) app.platform = {};
            if (!app.platform.image) app.platform.image = '/assets/favicon.png';
          });
        },
        err => {
          this.messageComponent.showError(
              "An error has ocurred while loading your applications, please try again later");
        });
  }


  remove(app) {
    this.users.removeUserApp(app).subscribe(
        res => { this.messageComponent.showSuccess("Application removed"); this.loadApps() },
        err => {          
          if (err.errors && err.errors.length > 0 &&
              err.errors[0].status == 500)
            this.messageComponent.showError(
                "An error has occurred while trying to remove this application");
          else if (
              err.errors && err.errors.length > 0 &&
              err.errors[0].status != 500)
            this.messageComponent.showError(err.errors[0].message);
          else
            this.messageComponent.showError(
                "An error has ocurred while handling your request");
        });
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/apps/apps.ts